import { render, staticRenderFns } from "./PassReset.vue?vue&type=template&id=82e49726&scoped=true&"
import script from "./PassReset.vue?vue&type=script&lang=js&"
export * from "./PassReset.vue?vue&type=script&lang=js&"
import style0 from "./PassReset.vue?vue&type=style&index=0&id=82e49726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e49726",
  null
  
)

export default component.exports